module.exports = __webpack_public_path__ + "img/xiaogou.1b5946a1.png";